"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeErrors = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var mergeArray = function mergeArray(fields, form) {
  if (!fields) return form;

  if (!Array.isArray(form)) {
    fields.error = form;
    return fields;
  }

  if (!Array.isArray(fields)) {
    form.error = fields;
    return form;
  }

  return form.reduce(function (acc, value, index) {
    acc[index] = mergeObject(acc[index], value);
    return acc;
  }, fields);
};

var mergeObject = function mergeObject(fields, form) {
  if (!fields) return form;
  if (!form) return fields;
  return Object.entries(form).reduce(function (acc, _ref) {
    var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    if (Array.isArray(acc[key]) || Array.isArray(value)) {
      acc[key] = mergeArray(acc[key], value);
    } else {
      acc[key] = value;
    }

    return acc;
  }, fields);
};

var mergeErrors = function mergeErrors(fields, form) {
  return mergeObject(fields, form);
};

exports.mergeErrors = mergeErrors;